var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calendar-component-row",class:{
        'calendar-component-row-current' : _vm.currentDay,
        'calendar-component-row-prev' : _vm.prevDay,
        'calendar-component-row-available' : !_vm.available,
        'calendar-component-row-block' : _vm.is_block
    },style:(("margin-left: " + _vm.firstDate + "px")),on:{"click":function($event){return _vm.clickDate()}}},[_c('span',[_vm._v(_vm._s(_vm.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }